import { Button, EmptyState, ErrorState } from '@nolens/ui';
import { isRouteErrorResponse, Link, useRouteError } from 'react-router';
import { ApiError } from '../lib/api';

export function RouteError() {
  const error = useRouteError();
  if ((isRouteErrorResponse(error) && error.status === 404) || (error instanceof ApiError && error.status === 404)) {
    return <NotFound />;
  }
  return (
    <ErrorState
      title="Algo correu mal"
      description="Não foi possível mostrar esta página. Tente novamente; se o problema persistir, contacte a sua clínica."
      onRetry={() => window.location.reload()}
      requestId={error instanceof ApiError ? error.requestId : undefined}
    />
  );
}

export function NotFound() {
  return (
    <EmptyState
      title="Página não encontrada"
      description="O endereço pode estar errado ou já não tem acesso a esta página."
      action={
        <Link to="/">
          <Button variant="secondary">Voltar ao início</Button>
        </Link>
      }
    />
  );
}

export function ConfigMissing() {
  return (
    <EmptyState
      title="Configuração em falta"
      description="Defina VITE_SUPABASE_URL, VITE_SUPABASE_PUBLISHABLE_KEY e VITE_API_URL (ver apps/web/.env.example)."
    />
  );
}
